import { StockAge } from '@loom-api-types'

export const STOCK_AGE_LABELS = {
  [StockAge.All]: 'All stock',
  [StockAge.Ewes]: 'Ewes',
  [StockAge.Hoggets]: 'Hoggets',
  [StockAge.Lambs]: 'Lambs',
  [StockAge.Wethers]: 'Wethers',
  [StockAge.Unclassified]: 'Unclassified',
}
